import React, { useState } from 'react';
import ResultCard from './ResultCard';
import ResultListMenu from './ResultListMenu';
import './ResultCardList.css';
import { useConfig } from "./ConfigContext";
import { textToSpeech } from './services/apiService';


const ResultCardList = ({ items, title, originalQuery, selectedFeature, aiSearchMode, accordionInfo }) => {
    const config = useConfig()
    const [ttsError, setTtsError] = useState(null);
    const [ttsLoading, setTtsLoading] = useState(false);

    const headingText = (selectedFeature === 'search' && aiSearchMode === 'free-text')
        ? "Ergebnisse basierend auf Filtern zu: " + (originalQuery || title)
        : "Ergebnisse für: " + title;


    const handleReadResultsAloud = async () => {
        setTtsError(null);

        if (!items || items.length === 0) {
            setTtsError("There are no results to read aloud.");
            return;
        }

        const maxItems = 5;
        const toRead = items.slice(0, maxItems);

        const textParts = toRead.map(function (item, index) {
            const num = index + 1;
            const title =
                item.title ||
                item.broadcast_series_title ||
                "Ohne Titel";

            return "Ergebnis " + num + ": " + title + ".";
        });

        const text = textParts.join("\n\n");

        if (!text.trim()) {
            setTtsError("Could not generate meaningful text to read aloud.");
            return;
        }

        setTtsLoading(true);

        try {
            const res = await textToSpeech(config, { text: text, format: "mp3" })
            // Read binary audio bytes
            const reader = res.body.getReader();
            const chunks = [];

            while (true) {
                const { value, done } = await reader.read();
                if (done) break;
                if (value) chunks.push(value);
            }

            const blob = new Blob(chunks, { type: "audio/mpeg" });
            const url = URL.createObjectURL(blob);

            const audio = new Audio(url);
            window._ttsAudio = audio;
            await audio.play();
        } catch (err) {
            console.error(err);
            setTtsError("The results could not be read aloud.");
        } finally {
            setTtsLoading(false);
        }
    }

    return (
        <div className='card-list-container'>
            <div className="card-list-title theken-search">
                <ResultListMenu
                    feature={selectedFeature}
                    aiSearchMode={aiSearchMode}
                    ardLink={"https://www.ardmediathek.de/suche/" + originalQuery}
                    handleReadResultsAloud={handleReadResultsAloud}
                    ttsLoading={ttsLoading}
                    ttsError={ttsError}
                    accordionInfo={accordionInfo}
                />
            </div>
            <div className="card-list-heading">{headingText}</div>
            <div className="card-list">
                {items.length === 0
                    ?
                    <div>Keine Treffer gefunden</div>
                    :
                    items.map((item, index) => (
                        <ResultCard
                            key={index}
                            image={item.teaser_image_url}
                            showTitle={item.show_title || ""}
                            title={item.title}
                            link={item.live_url}
                            genreCategory={item.genreCategory}
                            subgenreCategories={item.subgenreCategories}
                            thematicCategories={item.thematicCategories}
                            publicationDate={item.publication_date}
                        />
                    ))
                }
            </div>
        </div>
    );
};
export default ResultCardList;